<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <section class="search">
            <div class="row">
              <div class="col-10 offset-1">
                <p class="text-center">請以關鍵字搜尋客戶後選擇其中一位：</p>
                <form class="form">
                  <div class="input-group input-lg">
                    <div class="input">
                      <input
                        type="text"
                        maxlength="100"
                        name="keyword"
                        id="keyowrd"
                        class="form-control"
                        v-model="keyword"
                        placeholder="輸入客戶姓名進行搜尋"
                        @input="checkKeyword"
                        @blur="checkKeyword"
                        alt="ch"
                        @keyup.enter="findClient()"
                      />
                      <span
                        id="searchclear"
                        v-show="keyword"
                        @click="cleanSearch()"
                        >清除</span
                      >
                    </div>
                    <button
                      class="btn btn-primary btn-icon"
                      type="submit"
                      @click.stop.prevent="findClient()"
                    >
                      <i class="icon-search i-24"></i>
                    </button>
                  </div>
                </form>
                <p
                  v-if="custs && custs.length > 0"
                  class="text-danger text-bold pl-5 pt-2"
                >
                  ※畫面上僅能搜尋有「身分證字號」與「生日」的客戶。
                </p>
              </div>
            </div>
          </section>
          <section class="maintain mt-3">
            <div class="row">
              <div class="col-10 offset-1">
                <div class="row">
                  <div
                    class="col-6"
                    v-for="(c, cid) in clientList"
                    :key="`search-client-${cid}`"
                  >
                    <div class="radio">
                      <input
                        type="radio"
                        name="selection"
                        :id="`selection-${cid}`"
                        v-model="selection"
                        :value="c"
                      />
                      <label
                        :for="`selection-${cid}`"
                        class="scrollData"
                        style="display: inline"
                      >
                        <truncate-tool
                          :content="c.name"
                          position="bottom"
                        ></truncate-tool>
                      </label>
                      <span v-if="c.age || c.age === 0"> ({{ c.age }}歲) </span>
                      <span v-else>({{ c.birthday | ageCounter }}歲) </span>
                    </div>
                  </div>
                  <div
                    v-if="clientLoading"
                    :class="{ 'section-loading': true }"
                    class="col-12 text-center"
                  >
                    <h1 class="m-5">Loading</h1>
                  </div>
                  <div
                    v-else-if="clientList.length === 0 && !isFirst"
                    class="col-12 text-center"
                  >
                    <h3 class="m-5">查無任何客戶</h3>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="action text-right">
            <a class="btn btn-default" @click="$emit('close')"> 取消 </a>
            <a class="btn btn-primary" @click="doSubmit" :disabled="!selection">
              確認
            </a>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCustomers } from "../../service";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool.vue";

export default {
  name: "SearchClientModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custs: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selDataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    TruncateTool
  },
  data() {
    return {
      clientLoading: false,
      error: false,
      keyword: "",
      list: [],
      selection: null,
      clientList: [],
      isFirst: true
    };
  },
  watch: {
    keyword: "initList",
    open: "cleanSearch"
  },
  methods: {
    initList() {
      this.list = [];
      this.clientList = [];
      this.isFirst = true;
    },
    findClient() {
      this.queryCustList();
      if (this.keyword === "") {
        this.initList();
      }
    },
    doSubmit() {
      this.$emit("submit", this.selection);
    },
    queryCustList() {
      this.clientLoading = true;
      this.clientList = [];
      getCustomers(
        this.$store.state.userInfo.id,
        this.keyword,
        "1",
        "1",
        "1",
        "1",
        "1",
        "1"
      ).then((result) => {
        if (result.body) {
          this.clientList = result.body.customer_list.map((eachCust) => {
            return {
              name: eachCust.name || "",
              birthday: eachCust.birthday || "",
              age: this.getAge(eachCust.age),
              id: eachCust.id,
              ser_no: eachCust.ser_no
            };
          });
          //查詢結果動態排除List
          if (this.custs && this.custs.length > 0) {
            this.clientList = this.filterOutById(this.clientList, this.custs);
          }

          //查詢結果動態排除下拉清單資料(要保人、主被保人、次被保人)
          if (this.selDataList && this.selDataList.length > 0) {
            this.clientList = this.filterSelOutById(
              this.clientList,
              this.selDataList
            );
          }
        } else {
          this.clientList = [];
        }
        this.clientLoading = false;
        this.isFirst = false;
        this.registerHanlink();
      });
    },
    getAge(value) {
      if (!value && value !== 0) {
        return "";
      }
      return value;
    },
    //排除List
    filterOutById(clientList, custs) {
      let rAry = new Set(custs.map((x) => x.csidno));
      let filterClientList = clientList.filter(
        (x) => x.birthday && x.id != '' && !rAry.has(x.id) && !rAry.has(x.ser_no)
      );
      return filterClientList;
    },
    //排除下拉清單資料
    filterSelOutById(clientList, selData) {
      let rAry = new Set(selData.map((x) => x.csidno));
      let rAryOth = new Set(
        selData.map((x) => x.csidno).filter((y) => y.substr(0, 1) === "~")
      );

      let filterClientList = clientList.filter((x) =>
        rAryOth ? !rAry.has(x.id) && !rAryOth.has(x.ser_no) : !rAry.has(x.id)
      );

      return filterClientList;
    },
    //檢查輸入欄位
    checkKeyword() {
      this.keyword = this.keyword.replace(
        /[<>!@#$^&,."'?%;_()+-/{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(this.keyword, false, 100) > 100) {
        this.keyword = this.keyword.substring(
          0,
          this.stringBytes(this.keyword, true, 100)
        );
      }
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    cleanSearch() {
      this.keyword = "";
      this.selection = null;
      this.initList();
    }
  }
};
</script>

<style lang="scss" scoped>
.radio > input + label {
  height: auto;
}
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
</style>
